<template>
    <div class="video-embed">
        <component :is="embedComponent" :id="id" />
    </div>
</template>

<style lang="scss">
.video-embed {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    max-width: 100%;
    margin-bottom: 1rem;
    iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
}
</style>

<script>
import Vue from 'vue';

export default Vue.extend({
    name: 'VideoEmbed',
    props: {
        id: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
    },
    // Dynamically import the correct component
    components: {
        YouTube: () => import('./YouTube.vue'),
        Vimeo:   () => import('./Vimeo.vue'),
    },
    computed: {
        embedComponent() {
            switch (this.type) {
                case 'youtube':
                    return 'YouTube';
                case 'vimeo':
                    return 'Vimeo';
                default:
                    throw new Error(`Unknown video type: ${this.type}`);
            }
        },
    },
});
</script>
